module.exports = __webpack_public_path__ + "media/images/icon/navigation/explore-1431e5fc13313e9edca27871dfcae33c.svg";